<template>
<div class="formGroup">
  <formLabel :label="label" :validation="validation"></formLabel>
  <input
    type="file"
    :name="name"
    @change="test($event)"
    :v-validate="validation"
  ><br>
  <div v-show="readFile" class="preview">
    <img :src="readFile">
  </div>
</div>
</template>

<script>
import mixin from './mixin'

export default {
  name: 'form-file',
  mixins: [mixin],
  data: () => ({
    readFile: ''
  }),
  methods: {
    test($event) {
      this.upload($event.target.files[0]).then(res => {
        this.readFile = res
      })
    },
    upload(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = function() {
          resolve(reader.result)
        }
        reader.readAsDataURL(file);
      })
    }
  }
}</script>

<style lang="scss">
.preview {
  width: 64px;
  height: 64px;
  border-radius: 4px;
  > img {
    width: inherit;
    height: inherit;
    object-fit: cover;
    border: 2px solid #888;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/forms/FormFile.vue